import { ToolTip } from "@root/shared/components/ToolTip";
import { type FC, useState } from "react";
import { Icon } from "@root/shared/components/Icon";
import { colors } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";

export const UserInformationNoteText: FC = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className={styles.wrapper}>
      <span className={styles.title}>備考：</span>
      <span className={styles.contentText}>
        応募時の質問・メッセージあり
        <span
          className={styles.iconWrapper}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Icon name="tooltip" color={colors.TextLight} fontSize="16px" />
        </span>
      </span>
      <ToolTip arrowPosition="leftMiddle" isHovered={isHovered} className={styles.toolTip}>
        メッセージをご確認ください
      </ToolTip>
    </div>
  );
};
